import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="w-full mx-auto bg-white rounded-lg shadow-lg p-8 sm:p-12">
        <h1 className="text-4xl font-extrabold text-center text-gray-800 mb-6 border-b pb-4">
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-6 text-center max-w-2xl mx-auto">
          Your privacy matters. At{" "}
          <span className="font-semibold text-gray-800">Brick & Bar</span>, we
          are committed to protecting your personal information and being
          transparent about how we use it.
        </p>

        {/* Section */}
        <div className="space-y-8 text-gray-700 leading-relaxed">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              1. Information We Collect
            </h2>
            <p>
              We collect various types of personal data, including but not
              limited to:
            </p>
            <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
              <li>Name and contact details</li>
              <li>Shipping and billing address</li>
              <li>Payment information</li>
              <li>Browsing behavior</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              2. How We Use Your Information
            </h2>
            <p>We use your information to:</p>
            <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
              <li>Process and ship your orders</li>
              <li>Send order updates and promotional emails</li>
              <li>Improve user experience on our site</li>
              <li>Provide customer support</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              3. Sharing Your Data
            </h2>
            <p>
              We don’t sell or rent your data. We only share it with trusted
              third parties when necessary to fulfill your orders or improve our
              service.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              4. Data Security
            </h2>
            <p>
              We use modern security practices and tools to protect your data
              from unauthorized access, misuse, or disclosure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              5. Cookies
            </h2>
            <p>
              Our site uses cookies to provide essential functions, analyze
              traffic, and improve your experience. You may control cookie
              settings through your browser.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              6. Your Rights
            </h2>
            <p>
              You have the right to request access, update, or delete your
              personal data. Email us at{" "}
              <a
                href="mailto:support@bricknbar.com"
                className="text-blue-600 hover:underline"
              >
                support@bricknbar.com
              </a>{" "}
              for assistance.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              7. Updates to Policy
            </h2>
            <p>
              We may update this policy from time to time. Changes will be
              posted on this page with the effective date.
            </p>
          </div>
        </div>

        {/* <p className="mt-12 text-center text-sm text-gray-500">
          Last updated: <span className="italic">May 13, 2025</span>
        </p> */}
      </div>
    </section>
  );
};

export default PrivacyPolicy;
